/**
 * Platform wordmark used in navigation. It is text rather than a baked image so the
 * current HOTGAME name stays crisp and consistent at every viewport size.
 */
export function Logo({ height = 40, className = "" }: { height?: number; className?: string }) {
  return (
    <span
      aria-label="HOTGAME"
      role="img"
      className={`display inline-flex items-baseline leading-none whitespace-nowrap ${className}`}
      style={{ fontSize: height * 0.62 }}
    >
      <span className="text-candy">HOT</span>
      <span className="text-ink">GAME</span>
    </span>
  );
}
